module.exports = __webpack_public_path__ + "static/media/purepapercolor-skin-deep-sky-014-1200x2490.87c0bd85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapercolor-skin-deep-sky-014-1200x2490.jpg
// module id = 1094
// module chunks = 37